import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import TextField from '@material-ui/core/TextField';

function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        value: values.value,
                    },
                });
            }}
            allowNegative={false}
            thousandSeparator
            isNumericString
            prefix="$"
        />
    );
}

NumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
};

export function DollarFormatInput(props) {
    const { input, meta, ...rest } = props;
    return (
        <TextField
            {...input}
            {...rest}
            onChange={event => input.onChange(event.target.value)}
            InputProps={{
                inputComponent: NumberFormatCustom,
            }}
            errorText={meta.touched ? meta.error : ''}
            margin="normal"
        />
    );
}
